import React from 'react';
import { BreadCrumbGroup } from 'apps/sigma2-ui/src/components/ui/BreadcrumbGroup';
import { BreadCrumbItem } from 'apps/sigma2-ui/src/components/ui/BreadcrumbGroup';

export interface BreadcrumbEntry {
  label: string;
  to: string;
}

export const AdminBreadcrumbs: React.FC<{ items: BreadcrumbEntry[] }> = ({
  items,
}) => (
  <BreadCrumbGroup>
    {items.map((item, idx) => (
      <BreadCrumbItem key={item.to} to={item.to}>
        {item.label}
      </BreadCrumbItem>
    ))}
  </BreadCrumbGroup>
);
